import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { TNetService } from "src/app/services/tNet.service";
import { fromEvent, Observable, Subscription } from "rxjs";

@Component({
  selector: "app-t-net-companies",
  templateUrl: "./t-net-companies.component.html",
  styleUrls: ["./t-net-companies.component.scss"],
})
export class TNetCompanies implements OnInit, OnDestroy {
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public TNetCompaniesList = [
    {
      name: "myAuto",
      url: "https://www.myauto.ge/ka/",
      logo: "myauto-logo.svg",
    },
    {
      name: "myParts",
      url: "https://www.myparts.ge/ka/",
      logo: "myparts-logo.svg",
    },
    {
      name: "myHome",
      url: "https://www.myhome.ge/ka/",
      logo: "myhome-logo.svg",
    },
    {
      name: "myMarket",
      url: "https://www.mymarket.ge/ka/",
      logo: "mymarket-logo.svg",
    },
    { name: "myjobs", url: "https://myjobs.ge/", logo: "myjobs-logo.svg" },
    { name: "tkt", url: "https://www.tkt.ge/", logo: "tkt-logo.svg" },
    { name: "swoop", url: "https://www.swoop.ge/", logo: "swoop-logo.svg" },
    { name: "livo", url: "https://www.livo.ge", logo: "livo-logo.svg" },
    // { name: "saba", url: "https://saba.com.ge/", logo: "saba-logo.png" },
    {
      name: "superApp",
      url: "https://superapp.tnet.ge/",
      urls: {
        web: "https://superapp.tnet.ge/",
        android:
          "https://play.google.com/store/apps/details?id=ge.tnet.superapp&pli=1",
        ios: "https://apps.apple.com/us/app/super-app-tnet/id6444474250",
      },
      logo: "superapp-logo.svg",
    },
    { name: "esim", url: "https://superesim.ge/", logo: "esim-logo.svg" },
  ];

  @ViewChild("tnetModalToggle") tnetModalToggle: ElementRef;

  constructor(private tnetService: TNetService) {}

  get tnetModalShow() {
    return this.tnetService.modalShow;
  }
  closeTnetModal(data) {
    this.tnetService.setTnetCompaniesModal(data);
  }
  getMobileOS() {
    const ua = navigator.userAgent;
    const superApp = this.TNetCompaniesList.find(
      (item) => item.name === "superApp",
    );
    const index = this.TNetCompaniesList.indexOf(superApp);
    if (/android/i.test(ua)) {
      this.TNetCompaniesList[index].url =
        this.TNetCompaniesList[index].urls.android;
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      this.TNetCompaniesList[index].url =
        this.TNetCompaniesList[index].urls.ios;
    }
  }

  ngOnInit() {
    this.getMobileOS();
    this.resizeObservable$ = fromEvent(window, "resize");
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
      this.getMobileOS();
    });
  }
  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
  }
}
